export default __webpack_public_path__ + "static/media/FoodIllustration.cd00fa35.svg";